import { render, staticRenderFns } from "./TotalInsurableValueBound.vue?vue&type=template&id=22a0f180&scoped=true&"
import script from "./TotalInsurableValueBound.vue?vue&type=script&lang=js&"
export * from "./TotalInsurableValueBound.vue?vue&type=script&lang=js&"
import style0 from "./TotalInsurableValueBound.vue?vue&type=style&index=0&id=22a0f180&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0f180",
  null
  
)

export default component.exports